export async function getGuest(server) {
  let guestId = localStorage.getItem("guestId");

  if (!guestId) {
    const res = await fetch(`${server}/api/create-guest`, { method: "POST" });
    const data = await res.json();
    guestId = data.guestId;
    localStorage.setItem("guestId", guestId);
  }

  // گرفتن اطلاعات کامل Guest
  const res = await fetch(`${server}/api/guest/${guestId}`);
  const guest = await res.json();
  if(guest.error){
    localStorage.removeItem("guestId");
    getGuest(server)
  }else{


  return guest;
  }

}